import { GridColDef } from "@mui/x-data-grid";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";
import UpdateChargePopup from "../../../components/Fleet/UpdateChargePopup/UpdateChargePopup";

export const chargesTableColumns: GridColDef[] = [
  { field: "driverName", headerName: "Driver", width: 150 },
  { field: "ownerCompanyName", headerName: "Company", width: 180 },
  { field: "reason", headerName: "Reason", width: 200 },
  { field: "caseNumber", headerName: "Case Number", width: 150 },
  {
    field: "dateCommited",
    headerName: "Date Commited",
    width: 150,
    valueFormatter: (params) => new Date(params).toLocaleDateString(),
  },
  {
    field: "amount",
    headerName: "Amount",
    width: 120,
    valueFormatter: (params) => (params ? `$${params}` : ""),
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 200,
  },
  {
    field: "update",
    headerName: "",
    width: 130,
    renderCell: (params) => <UpdateChargePopup charge={params.row} />,
  },
  {
    field: "delete",
    headerName: "",
    width: 130,
    renderCell: (params) => (
      <ConfirmActionButton
        id={params.row.id}
        entityType="Charge"
        actionType="delete"
        entityLabel="charge"
        queryKey="charges"
        buttonLabel="Delete"
        buttonColor="error"
      />
    ),
  },
];
